import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { CatalogBrowser, CatalogBrowserProps } from './CatalogBrowser';

export type EmbeddableCatalogBrowserProps = VizPortalDataCatalogProviderProps &
  CatalogBrowserProps;

export function EmbeddableCatalogBrowserWithoutRouter(
  props: EmbeddableCatalogBrowserProps
): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <CatalogBrowser
        hideLaunchEditOnMobile={props.hideLaunchEditOnMobile}
        newFlowFromCatalog={props.newFlowFromCatalog}
        projectIdForNewDocuments={props.projectIdForNewDocuments}
        renderDatabasesExplorer={props.renderDatabasesExplorer}
        renderTablesExplorer={props.renderTablesExplorer}
        registerErrorStore={props.registerErrorStore}
        unregisterErrorStore={props.unregisterErrorStore}
        featureFlags={props.featureFlags}
        webClientResult={props.webClientResult}
      />
    </LineageBrowserDataCatalogProvider>
  );
}
